var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: props.fill,
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.175a4.825 4.825 0 100 9.65 4.825 4.825 0 000-9.65zM5.575 12a6.425 6.425 0 1112.85 0 6.425 6.425 0 01-12.85 0zM12 .7a.8.8 0 01.8.8v1.875a.8.8 0 01-1.6 0V1.5a.8.8 0 01.8-.8zM4.01 4.01a.8.8 0 011.131 0l1.326 1.326a.8.8 0 11-1.131 1.13L4.01 5.142a.8.8 0 010-1.131zM.7 12a.8.8 0 01.8-.8h1.875a.8.8 0 010 1.6H1.5a.8.8 0 01-.8-.8zM6.467 17.533a.8.8 0 010 1.131L5.14 19.99A.8.8 0 014.01 18.86l1.326-1.326a.8.8 0 011.13 0zM12 19.825a.8.8 0 01.8.8V22.5a.8.8 0 01-1.6 0v-1.875a.8.8 0 01.8-.8zM17.533 17.533a.8.8 0 011.131 0l1.326 1.326a.8.8 0 01-1.131 1.131l-1.326-1.325a.8.8 0 010-1.132zM19.825 12a.8.8 0 01.8-.8H22.5a.8.8 0 010 1.6h-1.875a.8.8 0 01-.8-.8zM19.99 4.01a.8.8 0 010 1.131l-1.325 1.326a.8.8 0 01-1.132-1.131L18.86 4.01a.8.8 0 011.131 0z"
  }))));
}

export default SvgSun;